import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/fa-build/src/components/pages/home/instructors/Instructors.js");
